import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-view-pdf-video",
  templateUrl: "./view-pdf-video.component.html",
  styles: [
    `
      :host {
        position: relative;
        display: block;
      }
      button {
        position: absolute;
        top: 0;
        right: 0;
      }
    `,
  ],
})
export class ViewPdfVideoComponent implements OnInit {
  item: string;
  extension: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ViewPdfVideoComponent>
  ) {}

  ngOnInit() {
    var extn = this.data.fileUrls.name.split(".").pop();
    this.extension = extn;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
